import styled from '@emotion/styled';
import { PropsWithChildren, ReactElement } from 'react';
import { Typography, TypographyVariant } from '../typography/typography';

export interface MonogramProps extends PropsWithChildren {
  name: string | ReactElement;
  isUpperCase?: boolean;
  size?: string;
  background?: string;
  textVariant?: TypographyVariant;
}

const ImageWrapper = styled.div<Partial<MonogramProps>>`
  width: ${(props) => props.size || '50px'};
  height: ${(props) => props.size || '50px'};
  border-radius: 50%;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.background || 'var(--md-ref-neutral-90)'};
`;

export const Monogram = ({
  name,
  isUpperCase,
  size,
  background,
  textVariant = 'textTitleMediumNeutral10',
}: MonogramProps) => {
  return (
    <ImageWrapper size={size} background={background}>
      {name && (
        <Typography variant={textVariant}>
          {typeof name === 'string'
            ? isUpperCase !== false
              ? name[0].toUpperCase()
              : name
            : name}
        </Typography>
      )}
    </ImageWrapper>
  );
};
